import BigNumber from 'bignumber.js';
import { encodeDecode } from './base.mjs';
import { u128 } from './bigint.mjs';
export var WAD = new BigNumber('1e+18');
export var decimal = function decimal(property) {
  var layout = u128(property);

  var _encodeDecode = encodeDecode(layout),
      encode = _encodeDecode.encode,
      decode = _encodeDecode.decode;

  var decimalLayout = layout;

  decimalLayout.decode = function (buffer, offset) {
    var src = decode(buffer, offset).toString();
    return new BigNumber(src).div(WAD);
  };

  decimalLayout.encode = function (decimal, buffer, offset) {
    var src = BigInt(decimal.times(WAD).integerValue().toString());
    return encode(src, buffer, offset);
  };

  return decimalLayout;
};